import { ICashFlowBase } from "services/cash-flow/types";
import { IInfinitePageResponse } from "services/types";

interface Amount {
  grossAmount: number;
  netAmount: number;
}

export enum BALANCE_TYPE {
  income = 0,
  cost = 1,
}

export enum INCOME_TYPE {
  unknown = -1,
  cost = 0,
  basic = 1,
  repaysAdvance = 2,
  repaysCost = 3,
}

export interface IFinancesDetail {
  id: string;
  name: string;
  amountToRepayment: number;
  tax: number;
  fileUrl: string | null;
  amount: Amount;
  type: BALANCE_TYPE;
  incomeType: INCOME_TYPE;
}

export interface ResponseHandlerResult
  extends IInfinitePageResponse<IFinancesDetail> {}

export interface IIncomeResponse extends ICashFlowResponse {
  incomeName: string;
  incomeType: INCOME_TYPE;
}
export interface ICashFlowRepaymentSourceResponse {
  name: REPAYMENT_SOURCE;
  id: number;
}
export interface ICashFlowAmountResponse {
  grossAmount: number;
  netAmount: number;
}
export interface ICashFlowRepaymentsResponse {
  amount: number;
  repaymentDate: Date;
  settlementId: string | null;
  repaymentSource: ICashFlowRepaymentSourceResponse;
  isPaidFromNet: boolean;
  repaymentDocument: {
    number: {
      shortcut: string;
      number: number;
      month: number;
      year: number;
      value: string;
    };
    id: string;
    fileName: string;
    path: string;
    sizeInMB: number;
    createdAt: Date;
    extension: string;
    mD5Hash: string;
  };
}

export interface ICashFlowResponse {
  id: string;
  remainingNetAmount: number;
  tax: number;
  fileUrl: null | null;
  amount: ICashFlowAmountResponse;
  repayments: ICashFlowRepaymentsResponse[];
  repaymentsFromAllContracts?: boolean;
  contracts?: string[];
  settlementId?: string;
  settlementName?: string;
  settlementPeriodId?: string;
  settlementPeriod: { name: string; year: number } | null;
}

export enum REPAYMENT_SOURCE {
  contract = "contract",
  income = "income",
}

export interface ICostResponse extends ICashFlowResponse {
  costName: string;
}

export interface ICostMutation extends ICashFlowBase {
  costName: string;
  settlementId: string;
}
